// Português (do Brasil, com "você").
export default {
  nav: {
    home: "Início",
    search: "Buscar",
    explore: "Explorar",
    messages: "Mensagens",
    tribzz: "Tribzz",
    channels: "Canais",
    settings: "Ajustes",
  },

  language: {
    title: "Idioma",
    lead: "Escolha o idioma que o Tribzz usa com você. Ele acompanha sua conta até o app no seu celular.",
    note: "Posts e mensagens ficam no idioma em que foram escritos. Algumas telas ainda estão sendo traduzidas e aparecem em inglês por enquanto.",
    saved: "✓ Salvo",
    saving: "Salvando…",
    error: "Não foi possível salvar. Verifique sua conexão e tente de novo.",
    done: "Pronto",
  },

  settings: {
    kicker: "Sua conta",
    title: "Ajustes",
    editPhoto: "Editar foto do perfil",
    member: "Membro",
    profileComplete: "Perfil {pct}% completo",
    quickEdit: "👤 Editar perfil",
    quickTribzz: "◆ Meus Tribzz",
    quickSecurity: "🔐 Segurança",
    finishTitle: "Complete seu perfil",
    finishSub: "Adicione seu {fields} para as pessoas saberem que é você.",
    gathering: "Carregando sua conta…",
    fields: {
      name: "nome completo",
      image: "foto do perfil",
      email: "e-mail",
      phone: "telefone",
      description: "bio",
      more: "e mais {n}",
    },
    sections: {
      account: "Conta",
      membership: "Assinatura",
      create: "Crie e ganhe",
      stuff: "Suas coisas",
      community: "Comunidade e apps",
      support: "Suporte",
    },
    rows: {
      personal: { title: "Informações pessoais", sub: "Nome, usuário, foto, interesses, privacidade" },
      profilePage: { title: "Sua página de perfil", sub: "Veja o que os outros veem" },
      security: { title: "Segurança", sub: "Senha e acessos recentes" },
      notifications: { title: "Notificações", sub: "Alertas no celular, e-mail e horário de silêncio" },
      language: { title: "Idioma", sub: "O idioma que o Tribzz usa com você" },
      creator: { title: "Painel do criador", sub: "Ganhos, visualizações reais, clipes, lançamentos e lives" },
      business: { title: "Ferramentas de negócio", sub: "Pedidos para viagem, reservas, ingressos e orçamentos para seu Tribzz" },
      pro: { title: "Tribzz Pro", sub: "Ofereça seus serviços: seja verificado, encontrado e contratado" },
      tickets: { title: "Meus ingressos", sub: "Ingressos de eventos e seus QR codes" },
      savedShorts: { title: "Shorts salvos" },
      memories: { title: "Memórias" },
      invite: { title: "Convidar amigos", sub: "Traga sua galera para o Tribzz" },
      muzilly: { title: "Muzilly" },
      ideas: { title: "Mural de ideias", sub: "Vote no que o Tribzz vai criar a seguir" },
      help: { title: "Ajuda e perguntas frequentes", sub: "Respostas e suporte" },
      about: { title: "Sobre o Tribzz", sub: "Versão, termos e privacidade" },
    },
    pctLeft: "Faltam {n}%",
    plan: {
      admin: "Admin",
      subscriber: "◆ Assinante",
      free: "Membro gratuito",
    },
    membership: {
      fullAccess: "Acesso total",
      adminText: "Todos os recursos, para testes. Não é um plano pago, então não há nada para gerenciar ou cancelar.",
      adminUsage: "{n} minutos de live usados este mês · sem limite",
      perMonth: "US$ 5 / mês",
      usage: "{used} de {cap} minutos de live usados este mês",
      manage: "Gerenciar assinatura",
      opening: "Abrindo…",
      kicker: "◆ Assinatura Tribzz",
      bigLead: "Faça lives, poste mais,",
      bigAccent: "apoie o Tribzz.",
      perk1: "Poste mais de uma foto por vez",
      perk2: "Faça lives e assista às lives de outros membros",
      perk3: "Sem anúncios, e seus dados nunca são vendidos",
      subscribe: "Assinar · US$ 5 / mês",
      redirecting: "Redirecionando…",
    },
    library: {
      shortsEmpty: "Shorts que você salvou e suas playlists",
      saved: "{n} salvos",
      playlists: "{n} playlist | {n} playlists",
      memoriesEmpty: "Seus próprios stories, guardados depois de 24 horas",
      memories: "{n} memória | {n} memórias",
      freeSaves: "{used} de {limit} salvamentos grátis usados",
    },
    muzilly: {
      connectedAs: "Conectado como {name}",
      yourAccount: "sua conta Muzilly",
      yourAccountTitle: "Sua conta Muzilly",
      connectPrompt: "Artistas e ouvintes: conecte sua conta",
      connected: "● Conectado",
      linkedBody: "{name}: se você é artista, o que você posta publicamente aqui aparece na sua página do Muzilly. Se você é ouvinte, as músicas que você ouve aqui contam para os artistas que você segue.",
      intro: "Artistas: seus posts públicos aparecem na sua página do Muzilly. Ouvintes: as músicas que você ouve aqui contam para os artistas que você segue.",
      step1: "Abra o Muzilly e vá até o seu perfil.",
      step2: "Toque em Conectar Tribzz para receber um código de 8 caracteres.",
      step3: "Digite abaixo; ele vale por 10 minutos.",
      codeLabel: "Código do Muzilly",
      close: "Fechar",
      cancel: "Cancelar",
      disconnect: "Desconectar",
      working: "Processando…",
      connect: "Conectar",
      connecting: "Conectando…",
      errConnect: "Não foi possível conectar. Tente um código novo.",
      errDisconnect: "Não foi possível desconectar.",
    },
    signOut: "Sair",
    deleteAccount: "Excluir conta",
    deleteWarning: "Excluir sua conta é permanente e imediato. Seus posts, mensagens, check-ins e conexões são apagados na hora, e isso não pode ser desfeito.",
    deleteButton: "Excluir minha conta…",
    deleteTitle: "Excluir sua conta?",
    deleteText: "Isso apaga de forma permanente e imediata seu perfil, posts, mensagens e conexões. Não pode ser desfeito.",
    typeDelete: "Digite DELETE para confirmar",
    cancel: "Cancelar",
    deleting: "Excluindo…",
    deleteForever: "Excluir para sempre",
  },

  home: {
    notifications: "Notificações",
    overline: "A plataforma das pessoas · {date}",
    welcome: "◆ Que bom te ver, {name} ◆",
    welcomeAnon: "◆ Que bom te ver de volta ◆",
    deck: "Seus círculos, sua cultura: tudo aqui embaixo é só a capa de hoje.",
    news: {
      label: "Notícias Tribzz",
      all: "Todas as notícias →",
      listenTop: "Ouvir a principal notícia",
      listenLatest: "Ouvir as últimas · {n} notícias",
      topStory: "★ DESTAQUE",
      newsroom: "· Redação Tribzz",
      read: "Ler a notícia →",
      minRead: "{n} min de leitura",
      listen: "🎧 Ouvir",
    },
    topics: {
      local: "📍 Local",
      politics: "🗳 Política",
      government: "🏛 Governo",
      crime: "⚖️ Polícia e justiça",
      business: "💼 Negócios",
      education: "🎓 Educação",
      health: "🩺 Saúde",
      sports: "🏀 Esportes",
      culture: "🎨 Cultura",
      tech: "💻 Tecnologia",
      environment: "🌱 Meio ambiente",
      community: "🤝 Comunidade",
      news: "📰 Notícias",
    },
    ago: {
      minutes: "há {n} min",
      hours: "há {n} h",
      days: "há {n} d",
    },
    share: "Compartilhe algo",
    watch: {
      label: "Assista e crie",
      browseChannels: "Ver canais",
      startChannel: "Criar um canal",
      watchShorts: "Ver shorts",
      browseStores: "Ver lojas",
      launchStore: "Abrir uma loja",
    },
    explore: {
      label: "Do Explorar",
      headLine1: "O que estão dizendo",
      headLine2: "agora",
      intro: "O Explorar é onde a cultura acontece de verdade. Uma olhada rápida na capa de hoje; o resto está a um toque.",
      loading: "Preparando a edição de hoje…",
      house: "◆ Tribzz Daily",
      aMember: "Um membro",
      inGroup: "em {name}",
      readOn: "Ler no Explorar →",
      emptyTitle: "A capa está em branco.",
      emptySub: "Ninguém postou nas últimas 24 horas. Seja o primeiro.",
      enter: "Entrar no Explorar",
      vanishing: "Some em breve",
      hoursLeft: "Faltam {n} h",
    },
    live: {
      label: "Acontecendo agora",
      headA: "Tribzz públicos",
      headLive: "ao vivo",
      headB: "agora",
      intro: "Abertos a todos: entre e assista, mesmo sem ter entrado ainda.",
      badge: "● AO VIVO",
    },
    circles: {
      label: "Seus círculos",
      headA: "Quem está",
      headLive: "ao vivo",
      headB: "agora",
      intro: "Cada Tribzz é um espaço próprio, comandado por quem o criou. Veja quem está ao vivo e quem fez check-in neste minuto.",
      loading: "Vendo quem está por aí…",
      hereNow: "{n} aqui agora",
      nobody: "Ninguém fez check-in ainda",
      emptyTitle: "Você ainda não entrou em nenhum Tribzz.",
      emptySub: "Um restaurante, um time, uma pessoa: qualquer um pode criar um. Encontre o seu, ou crie.",
      browse: "Ver Tribzz",
      start: "Crie o seu",
    },
    people: {
      label: "Seu círculo",
      headA: "Pessoas para",
      headB: "se conectar",
      intro: "Tribzz em comum, a mesma cidade, os mesmos interesses: seja o que for que vocês tenham em comum, a gente encontra.",
      loading: "Procurando sua galera…",
      activeNow: "Online agora",
      member: "Membro",
      inGroup: "Em {name} com você",
      alsoInto: "Também curte {interest}",
      view: "Ver perfil",
      connected: "Conectados ✓",
      connect: "Conectar",
      emptyTitle: "Nenhuma sugestão por enquanto.",
      emptySub: "Adicione seus interesses ou sua cidade em Informações pessoais, ou entre em um Tribzz; qualquer um desses ajuda a gente a encontrar sua galera.",
    },
    connections: {
      headA: "Minhas",
      headB: "conexões",
      loading: "Carregando suas conexões…",
      emptyTitle: "Nenhuma conexão ainda.",
      emptySub: "Conecte-se com as pessoas acima e elas vão aparecer aqui.",
    },
  },

  categories: {
    moment: "Momento",
    here_now: "Aqui agora",
    ask: "Pergunta",
    poll: "Enquete",
    mood: "Humor",
    travel_plan: "Plano de viagem",
    music: "Música",
  },

  daily: {
    question: "Pergunta do dia",
    poll: "Enquete",
    wyr: "Você prefere",
    quote: "Citação",
    trivia: "Quiz",
    fact: "Você sabia?",
    riddle: "Charada",
    history: "Neste dia na história",
    recipe: "Receita rápida",
    diy: "Passo a passo",
  },
};